
import "./principal.scss";
import React, { useState, useRef, useEffect } from "react";
import PrincipalMenu from "../../components/Principal/principalMenu/PrincipalMenu";
import GroupsList from "../../components/Principal/groups/groupsList/GroupsList";
import { useNavigate } from "react-router-dom";
import Axios from "axios";
import { UserContext } from "../../context/userProvider";
import { dataDecrypt } from "../../utils/dataDecrypt";
import AddTeacherClass from "../../components/Principal/groups/addTeacherClass/addTeacherClass";
import Alert from "../../components/alert/Alert";
import CertificateTrackingLinks from "../../components/Principal/certificateTrackingLinks/CertificateTrackingLinks";
import MaterialCorrectionTrackingLinks from "../../components/Principal/materialCorrectionTrackingLinks/MaterialCorrectionTrackingLinks";
// import AddPromotion from "../../components/Principal/promotions/addPromotion";
// import EditPromotion from "../../components/Principal/promotions/editPromotion";
const Principal = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [selectedComponent, setSelectedComponent] = useState(null);
    const menuRef = useRef(null);
    const certificateTrackingLinksCache = useRef({});
    const materialCorrectionTrackingLinksCache = useRef({});
    const navigate = useNavigate();
    const [user, setUser] = React.useContext(UserContext);
    var sessionStorageArray = [];
    const [arrayAlerts, setArrayAlerts] = useState([]);
    const [isVisibleAlert, setIsVisibleAlert] = useState(false);

    const handleClickOutside = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            setMenuOpen(false);
        }
    };

    useEffect(() => {
        if (!localStorage.getItem("user")) {
            localStorage.removeItem("token");
        }

        Axios.get(process.env.REACT_APP_API_URL + "isUserAuth/", {
            headers: {
                "x-access-token": localStorage.getItem("token"),
            },
        }).then((response) => {
            if (response.data.auth === false) {
                localStorage.removeItem("token");
                localStorage.removeItem("user");
                navigate("/login");
            } else {
                if (Object.keys(user).length === 0) {
                    var userStorage = localStorage.getItem("user");
                    var userJson = dataDecrypt(userStorage);
                    setUser(userJson);

                    var checkAuth = false;
                    sessionStorageArray = dataDecrypt(localStorage.getItem("session"));

                    sessionStorageArray.forEach((e) => {
                        if (userJson.id === e.id) {
                            checkAuth = true;
                        }
                    });

                    if (
                        (userJson.idPriv.toString() !== process.env.REACT_APP_API_DIRECCION_PRIVILEGE &&
                            userJson.idPriv.toString() !== process.env.REACT_APP_API_SUPERADMIN_PRIVILEGE) ||
                        checkAuth !== true
                    ) {
                        navigate("/login");
                    }
                } else {
                    var checkAuth = false;
                    sessionStorageArray = dataDecrypt(localStorage.getItem("session"));

                    sessionStorageArray.forEach((e) => {
                        if (user.id === e.id) {
                            checkAuth = true;
                        }
                    });

                    if (
                        (user.idPriv.toString() !== process.env.REACT_APP_API_DIRECCION_PRIVILEGE &&
                            user.idPriv.toString() !== process.env.REACT_APP_API_SUPERADMIN_PRIVILEGE) ||
                        checkAuth !== true
                    ) {
                        navigate("/login");
                    }
                }
            }
        });
    }, []);

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleMenuClick = () => {
        setMenuOpen(!menuOpen);
    };

    const handleMenuItemClick = (item) => {
        if (item.status === "disabled") {
            return;
        }

        if (item.link && item.link !== "#") {
            window.open(item.link, "_blank", "noopener,noreferrer");
            return;
        }

        setSelectedComponent(item.name);
        setMenuOpen(false);
    };

    const handleCloseComponent = () => {
        setSelectedComponent(null);
    };

    const renderSelectedComponent = () => {
        switch (selectedComponent) {
            // case 'Tabla de grupos':
            // return <GroupsTable onClose={handleCloseComponent} />;
            case 'Listado de grupos':
                return <GroupsList onClose={handleCloseComponent} user={user} showAlert={showAlert} />;

            case "Agregar grupo":
                return <AddTeacherClass onClose={handleCloseComponent} user={user} showAlert={showAlert} />;

            case "Seguimiento de certificados":
                return (
                    <CertificateTrackingLinks
                        cacheTrackingLinks={certificateTrackingLinksCache}
                        showAlert={showAlert}
                    />
                );

            case "Seguimiento de corrección de material":
                return (
                    <MaterialCorrectionTrackingLinks
                        cacheTrackingLinks={materialCorrectionTrackingLinksCache}
                        showAlert={showAlert}
                    />
                );

            default:
                return <div></div>;
        }
    };

    const showAlert = (type, message) => {
        const id = Math.floor(Math.random() * 100) + 1;
        const alertObj = { id, type, message };

        setArrayAlerts((oldArray) => [alertObj, ...oldArray]);
        setIsVisibleAlert(true);
    };

    return (
        <div className="principal-main">
            <section className="principal-side-menu main-color" ref={menuRef}>
                <div className={`menu ${menuOpen ? "active" : ""}`}>
                    <PrincipalMenu onMenuItemClick={handleMenuItemClick} />
                </div>

                <div className="side-menu-bar" onClick={handleMenuClick}>
                    <span>{"||>"}</span>
                </div>
            </section>

            <section className="principal-contain">
                {renderSelectedComponent()}
            </section>

            <div className="divAlert">
                <Alert
                    arrayAlertsModule={arrayAlerts}
                    setArrayAlertsModule={setArrayAlerts}
                    isVisibleModule={isVisibleAlert}
                    setIsVisibleModule={setIsVisibleAlert}
                />
            </div>
        </div>
    );
};

export default Principal;
